import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchAllTransactions } from "../../features/transaction/transactionThunk";
import Transaction from "./Transaction";
import { Link } from "react-router-dom";

const LatestTransactions = () => {
	const dispatch = useDispatch();

	const { isLoading, isError, transactions } = useSelector(
		(state) => state.transaction
	);

	useEffect(() => {
		dispatch(fetchAllTransactions());
	}, [dispatch]);

	let content = null;

	if (isLoading) {
		content = <p className="">Loading</p>;
	}

	if (!isLoading && isError) {
		content = <p className="">There was an error occured!</p>;
	}

	if (!isLoading && !isError && transactions?.length > 0) {
		const latesTransactions = transactions.slice(-5).sort((a, b) => b.id - a.id);
		content = latesTransactions.map((transaction) => (
			<Transaction key={transaction.id} transaction={transaction} />
		));
	}
	if (!isLoading && !isError && transactions?.length === 0) {
		content = <p className="">No transaction found!</p>;
	}

	return (
		<div className="flex justify-center items-center sm:drop-shadow-lg pt-5">
			<div className="w-full md:w-2/3 lg:w-1/2 xl:w-2/4 2xl:w-1/3 p-4 md:p-6 pb-4 mb-4 bg-white border space-y-6">
				<h2 className="text-lg sm:text-xl border-b border-b-200 pb-2">
					Latest Transactions
				</h2>

				<div className="space-y-4">
					{content}

					{transactions?.length > 0 && (
						<div className="flex justify-center items-center pt-5">
							<Link to="/transactions">
								<p className="items-center underline text-indigo-600 cursor-pointer hover:text-blue-500">
									View All
								</p>
							</Link>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default LatestTransactions;
